<script>
	import { getContext, onDestroy, createEventDispatcher } from 'svelte'
	import { storeStorage } from '../scripts/Store.svelte'
	import { styles } from '../scripts/styles.js'

	const globals = getContext('globals')

	const dispatch = createEventDispatcher()

	export let borderColor = globals.inputBorder
	export let fontColor = globals.colorMain
	export let fontSize = globals.fsS
	export let backgroundColor = globals.inputBgFocus
	export let backgroundFocus = globals.inputBg
	export let width = '100%'
	export let safe = 'false'
	export let storage = null
	export let rows = '6'
	export let resize = 'none'
	export let cmd
	export let value = ''
	export let overflowY = 'hide'
	export let keydown = 'true'
	export let maxlength = '1000'
	export let placeHolder = 'placeholder'
	export let id = 'txtarea'

	let inputValue = value
	let inputError = false

	//timeout
	let toError

	const key_down = (e) => {
		if (e.keyCode === 13 && keydown === 'true') save_input()
	}

	const save_input = () => {
		if (safe === 'true') {
			let browserStorage = sessionStorage.getItem(storage)
			if (browserStorage === 'null' || browserStorage == null) {
				sessionStorage.setItem(storage, JSON.stringify({ [cmd]: inputValue }))
				storeStorage.set(JSON.stringify(browserStorage))
			} else {
				browserStorage = JSON.parse(browserStorage)
				browserStorage[cmd] = inputValue
				sessionStorage.setItem(storage, JSON.stringify(browserStorage))
				storeStorage.set(JSON.stringify(browserStorage))
			}
		}

		dispatch('input', {
			cmd: cmd,
			value: inputValue,
		})
	}

	onDestroy(() => {
		clearTimeout(toError)
	})
</script>

<main use:styles={{ width }}>
	{#if !inputError}
		<textarea
			on:focusout={save_input}
			on:keydown={(e) => key_down(e)}
			bind:value={inputValue}
			use:styles={{ borderColor, fontSize, fontColor, backgroundColor, backgroundFocus, width, resize, overflowY }}
			{id}
			{placeHolder}
			{rows}
			{maxlength}
		/>
	{/if}
</main>

<style>
	main {
		width: var(--width);
	}
	textarea {
		font-size: var(--fontSize);
		color: var(--fontColor);
		background: var(--backgroundColor);
		outline: none;
		width: var(--width);
		margin: 0;
		padding: 6px;
		border: 1px solid var(--borderColor);
		resize: var(--resize);
		overflow-y: var(--overflowY);
	}
</style>
